import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import DayCampWeekSelection from "../Components/DayCampWeekSelection";
import PersonalInfo from "../Components/PersonalInfo";
import MedicalInsuranceInformation from "../Components/MedicalInsuranceInformation";
import DayCampOptions from "../Components/DayCampOptions";
import ParentConsent from "../Components/ParentConsent";
import DataAccessHelper from '../Helper/DataAccessHelper';
import InputValidation from '../Helper/InputValidation';
import DayCampRegistrationReview from "../Components/DayCampRegistrationReview";
import DayCampRegistrationPayment from "../Components/DayCampRegistrationPayment";
import { DayCampPageOptions } from "../Constants/RegistrationPageOptions";
import DayCampRegistrationPaymentCashCheck from "../Components/DayCampRegistrationPaymentCashCheck";
import { registrationType } from '../Constants/RegistrationType';
import '../Styles/DayCampRegistration.scss';
import { setWeek } from "date-fns";

function AdminDayCampRegistration() {

   const location = useLocation();
   const account = location.state;
   const [paymentType, setPaymentType] = useState('')
   // Set alongside amountDue once Stripe confirms, so the effect-triggered ProcessRegistration can
   // record which charge paid for the registration. Stays null for cash/check.
   const [paymentIntentId, setPaymentIntentId] = useState(null)
   const [promoCode, setPromoCode] = useState({ isSelected: false, promoSelected: '', promoType: null, discountPercent: 0, discountAmount: 0, promoId: null })
   console.log("account", account)
   const navigate = useNavigate();
   const [amountDue, setAmountDue] = useState()
   const [eventAndDate, setEventAndDate] = useState({ groupCode: '' })
   const [signatureData, setSignatureData] = useState({ signature: '', signatureDate: null })
   const [eventInformation, setEventInformation] = useState();
   const [buddyFirstName, setBuddyFirstName] = useState('');
   const [buddyLastName, setBuddyLastName] = useState('')
   const [camperSignature, setCamperSignature] = useState('')
   const [camperSignatureDate, setCamperSignatureDate] = useState('')
   const [paymentAmount, setPaymentAmount] = useState()
   const [parentSignature, setParentSignature] = useState('')
   const [parentSignatureDate, setParentSignatureDate] = useState('')
   const [weekSelection, setWeekSelection] = useState('')
   const [selectedPage, setSelectedPage] = useState(DayCampPageOptions.WeekSelection)
   const [currentRegistrant, setCurrentRegistrant] = useState();
   const [authorizedIndividuals, setAuthorizedIndividuals] = useState(
      {
         individualOneFirstName: "",
         individualOneLastName: "",
         individualOneRelationship: "",
         individualOnePhone: "",
         individualTwoFirstName: "",
         individualTwoLastName: "",
         individualTwoRelationship: "",
         individualTwoPhone: "",
         individualThreeFirstName: "",
         individualThreeLastName: "",
         individualThreeRelationship: "",
         individualThreePhone: "",
         individualFourFirstName: "",
         individualFourLastName: "",
         individualFourRelationship: "",
         individualFourPhone: "",
         individualFiveFirstName: "",
         individualFiveLastName: "",
         individualFiveRelationship: "",
         individualFivePhone: "",
         individualSixFirstName: "",
         individualSixLastName: "",
         individualSixRelationship: "",
         individualSixPhone: ""
      })
   const [personalInformation, setPersonalInformation] = useState({
      firstName: '',
      lastName: '',
      gender: '',
      strAddress: '',
      city: '',
      state: '',
      zip: '',
      phone: '',
      ecName: '',
      ecRelationship: '',
      ecPhone: '',
      birthDate: ''
   })
   const [medicalInformation, setMedicalInformation] = useState({
      insuranceCompany: '',
      insuranceId: '',
      groupPolicyNumber: '',
      policyHolderName: '',
      policyHolderBirthdate: null,
      hasDiabetes: 'off',
      hasHeartCondition: 'off',
      hasEpilepsy: 'off',
      hasEnvironmentAllergies: 'off',
      hasHeatExhaustion: 'off',
      hasThyroidProblem: 'off',
      hasLupus: 'off',
      hasHighBloodPressure: 'off',
      hasAsthma: 'off',
      drugAllergies: '',
      emergencyAction1: '',
      foodAllergies: '',
      emergencyAction2: '',
      allergicReactions: '',
      otherAllergies: '',
      emergencyAction3: '',
      medicationName: '',
      medicationDose: '',
      tetanusShotDate: null
   })
   let eventRegistrationType = registrationType.Day
   let isAdmin = true;


   
   async function validateAndProcessRegistration(paymentIntentId) {
      try {
         const response = await fetch('/api/verify-payment', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ paymentIntentId }),
         });

         if (!response.ok) {
            console.error('Server returned an error verifying payment intent');
            return false
         }

         const data = await response.json();
         if (data.result.status === 'succeeded') {
            var pricePaid = InputValidation.shiftDecimalLeft(data.result.amount, 2)
            var eventPrice = Number(weekSelection.camp_fee) + Number(weekSelection.registration_fee)
            var undiscountedPaid = pricePaid
            if (promoCode.isSelected) {
               if (promoCode.discountPercent > 0 && promoCode.discountPercent < 100) {
                  undiscountedPaid = pricePaid / (1 - promoCode.discountPercent / 100)
               } else if (promoCode.discountAmount > 0) {
                  undiscountedPaid = pricePaid + promoCode.discountAmount
               }
            }
            const amountDue = (eventPrice - undiscountedPaid).toFixed(2);
            setPaymentIntentId(paymentIntentId)
            setAmountDue(amountDue)
            return true
         } else {
            console.warn('Payment not confirmed. Status:', data.result.status);
            return false
         }
      } catch (err) {
         console.error('Error validating payment intent:', err);
      }
   }

   async function ProcessRegistration() {
      var registrationResult = await AddRegistration()

      console.log("Payment amount", paymentAmount)
      // Written even at $0 so every registration has a row in the ledger.
      if (registrationResult) {
         await AddTransaction(registrationResult)
      }
      navigate('/registrationsearch', { state: { paymentAmount } })
   }


   async function AddRegistration() {
      try {
         const response = await fetch('/daycampregistration', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               account,
               buddyFirstName,
               buddyLastName,
               camperSignature,
               parentSignature,
               parentSignatureDate,
               weekSelection,
               authorizedIndividuals,
               amountDue,
               paymentAmount,
               personalInformation,
               medicalInformation
            })
         })
         let registrationResult = await response.json();
         return registrationResult.data.Registration[0].regist_id
      }
      catch (error) {
         console.log("Exception", error)
      }
   }

   async function AddTransaction(registrationId) {
      try {
         const transaction = await fetch('/addtransaction', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               transactionValue: paymentAmount,
               registId: registrationId,
               paymentType: paymentType,
               paymentIntentId
            })
         })
         let transactionResult = await transaction.json();
      } catch (error) {
         console.log("Exception", error)
      }
   }

   useEffect(() => {
      if (amountDue == null) return;
      ProcessRegistration();
   }, [amountDue]);

   return (
      <div className="DayCampRegistrationContainer">
         {selectedPage === DayCampPageOptions.WeekSelection &&
            <DayCampWeekSelection
               selectedPage={selectedPage}
               setSelectedPage={setSelectedPage}
               setEventInformation={setEventInformation}
               weekSelection={weekSelection}
               setWeekSelection={setWeekSelection}
               eventRegistrationType={eventRegistrationType} />
         }
         {selectedPage === DayCampPageOptions.PesonalInfo &&
            <PersonalInfo
               personalInformation={personalInformation}
               setPersonalInformation={setPersonalInformation}
               selectedPage={selectedPage}
               setSelectedPage={setSelectedPage}
               previousPage={DayCampPageOptions.WeekSelection}
               nextPage={DayCampPageOptions.MedicalInsurance} />
         }
         {selectedPage === DayCampPageOptions.MedicalInsurance &&
            <MedicalInsuranceInformation
               medicalInformation={medicalInformation}
               setMedicalInformation={setMedicalInformation}
               selectedPage={selectedPage}
               setSelectedPage={setSelectedPage}
               previousPage={DayCampPageOptions.PesonalInfo}
               nextPage={DayCampPageOptions.DayCampOptions}
            />
         }
         {selectedPage === DayCampPageOptions.DayCampOptions &&
            <DayCampOptions
               buddyFirstName={buddyFirstName}
               setBuddyFirstName={setBuddyFirstName}
               buddyLastName={buddyLastName}
               setBuddyLastName={setBuddyLastName}
               camperSignature={camperSignature}
               setCamperSignature={setCamperSignature}
               setCamperSignatureDate={setCamperSignatureDate}
               setSelectedPage={setSelectedPage} 
               previousPage={DayCampPageOptions.MedicalInsurance}
               nextPage={DayCampPageOptions.ParentConsent}/>
         }
         {selectedPage === DayCampPageOptions.ParentConsent &&
            <ParentConsent
               buddyFirstName={buddyFirstName}
               setSelectedPage={setSelectedPage}
               setBuddyFirstName={setBuddyFirstName}
               buddyLastName={buddyLastName}
               setBuddyLastName={setBuddyLastName}
               authorizedIndividuals={authorizedIndividuals}
               setAuthorizedIndividuals={setAuthorizedIndividuals}
               parentSignature={parentSignature}
               setParentSignature={setParentSignature}
               parentSignatureDate={parentSignatureDate}
               setParentSignatureDate={setParentSignatureDate}
               previousPage={DayCampPageOptions.DayCampOptions}
               nextPage={DayCampPageOptions.Review}
            />
         }
         {selectedPage === DayCampPageOptions.Review &&
            <DayCampRegistrationReview
               currentRegistrant={currentRegistrant}
               buddyFirstName={buddyFirstName}
               buddyLastName={buddyLastName}
               camperSignature={camperSignature}
               parentSignature={parentSignature}
               parentSignatureDate={parentSignatureDate}
               weekSelection={weekSelection}
               authorizedIndividuals={authorizedIndividuals}
               personalInformation={personalInformation}
               medicalInformation={medicalInformation}
               selectedPage={selectedPage}
               setSelectedPage={setSelectedPage}
               isAdmin={isAdmin}
            />
         }
         {selectedPage === DayCampPageOptions.Payment &&
            <DayCampRegistrationPayment
               account={account}
               amountDue={amountDue}
               setAmountDue={setAmountDue}
               paymentAmount={paymentAmount}
               setPaymentAmount={setPaymentAmount}
               weekSelection={weekSelection}
               ProcessRegistration={ProcessRegistration}
               validateAndProcessRegistration={validateAndProcessRegistration}
               paymentType={paymentType}
               setPaymentType={setPaymentType}
               promoCode={promoCode}
               setPromoCode={setPromoCode} />
         }
         {selectedPage === DayCampPageOptions.PaymentCashCheck &&
            <DayCampRegistrationPaymentCashCheck
               amountDue={amountDue}
               setAmountDue={setAmountDue}
               paymentAmount={paymentAmount}
               setPaymentAmount={setPaymentAmount}
               ProcessRegistration={ProcessRegistration}
               paymentType={paymentType}
               setPaymentType={setPaymentType} />
         }
      </div>
   )

}
export default AdminDayCampRegistration;